export const SECTION_RESULT_LIMIT = 3;

export const RESULTS_PAGE_SIZE = 10;
